import React from "react";
import styled, { keyframes } from "styled-components";

// shimmer animation
const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const SkeletonBlock = styled.div`
  height: ${(props) => props.height || "16px"};
  width: 100%;
  border-radius: 4px;
  background: #e2e8f0;
  background-image: linear-gradient(
    90deg,
    #e2e8f0 0px,
    #f1f5f9 40px,
    #e2e8f0 80px
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.2s infinite linear;
`;
// Skeleton Row
const SkeletonRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 12px 0;
  width: 100%;
`;

const TableSkeleton = ({ columns, rows = 5 }) => {
  return (
    <>
      {[...Array(rows)].map((_, rowIndex) => (
        <SkeletonRow key={rowIndex}>
           {columns.map((column, colIndex) => (
            <Cell
              key={colIndex}
              width={column.width}
              flex={column.flex}
              align={column.align}
            >
              <SkeletonBlock height="16px" />
            </Cell>
          ))}
        </SkeletonRow>
      ))}
    </>
  );
};

export default TableSkeleton;


const Cell = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.align || "flex-start"};
  flex: ${(props) => (props.flex ? "1" : "none")};
  gap: 8px;
  width: ${(props) => props.width || "auto"};
  box-sizing: border-box;

  /* Prevent text overflow */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  min-width: 0;
  @media (max-width: 768px) {
    min-width:100px;

    flex: 1;
  }
`;
